import { CO_CHAT } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { getCoChatChannels } from "../../api/cochat";
const initialState = {
  loading: false,
  activeChannel: "",
  channelList: [] as any,
  searchChannelList: [] as any,
  isNotificationMuted: false,
  messageList: [] as any,
  message: {},
  internalchatmessage: "",
  typeOfMessage: "",
};
const coChatSlice = createSlice({
  name: CO_CHAT,
  initialState,
  reducers: {
    channels: (state, { payload }) => {
      state.channelList = payload.channelList;
      state.searchChannelList = payload.searchChannelList;
    },
    enableMute: (state) => {
      state.isNotificationMuted = true;
    },
    disableMute: (state) => {
      state.isNotificationMuted = false;
    },
    updateActiveChannel: (state, { payload }) => {
      state.activeChannel = payload.activeChannel;
    },
    sendMessage: (state, { payload }) => {
      state.messageList.push(payload.message);
    },
    updateMessage: (state, { payload }) => {
      state.message = payload;
    },
    updateInternalMessage: (state, { payload }) => {
      state.internalchatmessage = payload;
    },
    updateTypeOfMessage: (state, { payload }) => {
      state.typeOfMessage = payload.typeOfMessage;
    },
    reset: () => {},
  },
  extraReducers: (builder) => {
    builder.addCase(getCoChatChannels.pending, (state, _) => {
      state.loading = true;
    });
    builder.addCase(getCoChatChannels.fulfilled, (state, { payload }: any) => {
      if (payload?.data?.statusCode === 200) {
        state.channelList = payload.data?.result;
        state.searchChannelList = payload.data?.result;
      } else {
        state.channelList = [];
        state.searchChannelList = [];
      }
      state.loading = false;
    });
    builder.addCase(getCoChatChannels.rejected, (state, _) => {
      state.loading = false;
    });
  },
});
export const cochatActions = coChatSlice.actions;
export default coChatSlice.reducer;
